var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4712 9.02232V17C6.4712 17.4142 6.80699 17.75 7.2212 17.75C7.63542 17.75 7.9712 17.4142 7.9712 17V8.34821C7.9712 7.18872 6.52951 6.65405 5.77347 7.53316L3.65257 9.99933C3.38248 10.3134 3.41812 10.7869 3.73217 11.057C4.04623 11.3271 4.51976 11.2914 4.78984 10.9774L6.4712 9.02232Z",
    fill: "#5032C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8913 9.53846C12.8913 10.112 12.4264 10.5769 11.8529 10.5769C11.2794 10.5769 10.8144 10.112 10.8144 9.53846C10.8144 8.96494 11.2794 8.5 11.8529 8.5C12.4264 8.5 12.8913 8.96494 12.8913 9.53846ZM13.3578 11.5829C13.9847 11.1207 14.3913 10.3771 14.3913 9.53846C14.3913 8.13651 13.2548 7 11.8529 7C10.4509 7 9.31442 8.13651 9.31442 9.53846C9.31442 10.3771 9.72108 11.1207 10.348 11.5829C9.23386 12.1369 8.46826 13.2867 8.46826 14.6154C8.46826 16.4847 9.98361 18 11.8529 18C13.7221 18 15.2375 16.4847 15.2375 14.6154C15.2375 13.2867 14.4719 12.1369 13.3578 11.5829ZM13.7375 14.6154C13.7375 15.6563 12.8937 16.5 11.8529 16.5C10.812 16.5 9.96826 15.6563 9.96826 14.6154C9.96826 13.5746 10.812 12.7308 11.8529 12.7308C12.8937 12.7308 13.7375 13.5746 13.7375 14.6154Z",
    fill: "#5032C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0198 9.75C19.0198 9.33579 18.684 9 18.2698 9C17.8556 9 17.5198 9.33579 17.5198 9.75V11.2825H15.9873C15.5731 11.2825 15.2373 11.6183 15.2373 12.0325C15.2373 12.4467 15.5731 12.7825 15.9873 12.7825H17.5198V14.315C17.5198 14.7292 17.8556 15.065 18.2698 15.065C18.684 15.065 19.0198 14.7292 19.0198 14.315V12.7825H20.5523C20.9665 12.7825 21.3023 12.4467 21.3023 12.0325C21.3023 11.6183 20.9665 11.2825 20.5523 11.2825H19.0198V9.75Z",
    fill: "#5032C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#5032C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18+.ce7bef86be3bd95e6576efbe4afcc45b.svg";
export { ForwardRef as ReactComponent };